import api from '..'

export async function deleteMarketingSpend(id: string): Promise<void> {
  await api.delete(`/marketing-spend/${id}`)
}
